import { ReservationSteps, } from '@reservation-app/common-used-in-web';
export const isWithPaymentStep = ({ selectedEntityType, companyReservationConfig, }) => {
    var _a;
    const selectedEntityTypeHasSteps = ((_a = selectedEntityType.steps) === null || _a === void 0 ? void 0 : _a.length) > 0;
    if (selectedEntityTypeHasSteps) {
        return selectedEntityType.steps.some(({ step }) => step === ReservationSteps.PAYMENT_DETAILS);
    }
    return companyReservationConfig.steps.some(({ step }) => step === ReservationSteps.PAYMENT_DETAILS);
};
